import { useEffect, useState } from "react";
import "./App.css";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { toast } from "react-toastify";
import Web3 from "web3";
import Electionabi from "./contracts/Election.json";

import NavBar from "./Components/NavBar";
import VoteDisplay from "./Components/VoteDisplay";

function App() {
  const [currentAccount, setCurrentAccount] = useState("");
  const [electionSm, setElectionSm] = useState(null);
  const [candidate1, setcandidate1] = useState(null);
  const [candidate2, setcandidate2] = useState(null);

  useEffect(() => {
    loadWeb3();
    loadBlockchainData();
  }, []);

  const loadWeb3 = async () => {
    if (window.ethereum) {
      await window.ethereum.enable();
    } else {
      toast(
        "Please Connect To A Wallet. Try Using Metamask Otherwise It Will Not Work.",
        {
          type: "error",
          autoClose: 15000,
        }
      );
    }
  };

  const loadBlockchainData = async () => {
    if (typeof window.ethereum == "undefined") {
      return;
    }

    const web3 = new Web3(window.ethereum);
    const accounts = await web3.eth.getAccounts();

    setCurrentAccount(accounts[0]);
    const networkId = await web3.eth.net.getId();

    const networkData = Electionabi.networks[networkId];

    if (networkData) {
      toast("Hit refresh every time you switch between accounts", {
        type: "info",
        autoClose: 15000,
      });

      const election = new web3.eth.Contract(
        Electionabi.abi,
        networkData.address
      );
      setElectionSm(election);
      const candidate1 = await election.methods.candidates(1).call();
      const candidate2 = await election.methods.candidates(2).call();
      setcandidate1(candidate1);
      setcandidate2(candidate2);
    } else {
      toast("Use Rinkeby Test Network", { type: "info", autoClose: 15000 });
    }
  };

  const VoteCandidate = async (candidateId) => {
    if (currentAccount) {
      <h1>Loading...</h1>;
      await electionSm.methods
        .vote(candidateId)
        .send({ from: currentAccount })
        .on("transactionhash", () => {});
    } else {
      toast("Login to your wallet or hit Refresh", {
        type: "info",
        autoClose: 7000,
      });
    }
  };

  return (
    <>
      <NavBar address={currentAccount} />
      <ToastContainer />
      <div className="container text-center">
        <h1 className="mt-3 text-center">Blockchain Voting Dapp</h1>
        <VoteDisplay
          candidate1={candidate1}
          candidate2={candidate2}
          VoteCandidate={VoteCandidate}
        />
      </div>
    </>
  );
}

export default App;
